export default class QuestionnaireAllergyStage {}

QuestionnaireAllergyStage.Welcome = 'WELCOME';
QuestionnaireAllergyStage.Location = 'LOCATION';
QuestionnaireAllergyStage.Pet = 'PET';
QuestionnaireAllergyStage.Triage = 'Triage';
QuestionnaireAllergyStage.Question = 'QUESTION';
QuestionnaireAllergyStage.Eligibility = 'ELIGIBILITY';

QuestionnaireAllergyStage.getBaseStages = () => [
  QuestionnaireAllergyStage.Welcome,
  QuestionnaireAllergyStage.Location,
  QuestionnaireAllergyStage.Pet,
  QuestionnaireAllergyStage.Triage,
  QuestionnaireAllergyStage.Eligibility,
];
